import { useTranslate, usePermissions } from '../../../../customHooks';
import { LoadingPanel } from '@panwds/react-ui';
import { FirewallUpdateBanner } from '../../FirewallUpdateBanner';
import styles from '../../FirewallEdit.module.scss';
import { GwlbTimeoutField } from './AdvancedSettingsComponents';
import { isFirewallUpdating } from '../../firewallsUtil';

const FirewallAdvancedSettings = (props: {
  firewallData: Record<string, any>;
  isLoading: boolean;
  refreshFirewallData: () => void;
  canEdit: boolean;
}) => {
  const translate = useTranslate();
  const { permissions } = usePermissions();

  const firewallUpdating = isFirewallUpdating(props?.firewallData?.Status?.FirewallStatus);

  const isFieldDisabled = firewallUpdating || !props.canEdit || !permissions?.UpdateFirewall;

  return (
    <div className="twcngfw-relative twcngfw-flex twcngfw-flex-col twcngfw-h-full">
      {props?.isLoading && (
        <div
          className="twcngfw-absolute twcngfw-inset-0 twcngfw-right-0 twcngfw-flex twcngfw-justify-center twcngfw-items-center twcngfw-backdrop-blur-sm twcngfw-z-50"
          style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)' }}
        >
          <div className="twcngfw-w-6 twcngfw-h-6">
            <LoadingPanel />
          </div>
        </div>
      )}
      {firewallUpdating && (
        <FirewallUpdateBanner refresh={props.refreshFirewallData} />
      )}
      <div className={styles.fwEditHeader} style={{ marginBottom: '24px' }}>
        {translate(`resources.firewallsV2.advancedSettings`)}
      </div>
      <div
        className={`${isFieldDisabled ? styles.fwReadOnly : ''}`}
      >
        <GwlbTimeoutField
          isDisabled={isFieldDisabled}
          firewallData={props.firewallData}
          refreshFirewallData={props.refreshFirewallData}
          formButtonsAtBottom={false}
        />
        {/* Future advanced settings fields can be added here */}
        {/* Set formButtonsAtBottom={true} for buttons at bottom when multiple fields exist */}
      </div>
    </div>
  );
};

export default FirewallAdvancedSettings;
